import {
  OpportunityPublicStatus,
  OpportunityStatus,
  OpportunityType,
} from "@platform-app/app/core/api/models";
import { OpportunityMode } from "@platform-app/app/main/my-opportunities/shared/models";
import { DuplicatedOpportunityModel } from "@platform-app/app/main/my-opportunities/shared/models";

export class SetCurrentOpportunity {
  static readonly type = "[My Opportunity] Set Current Opportunity";
  constructor(
    public payload: {
      id: string | null;
      title?: string | null;
      opportunityType?: OpportunityType | null;
      currentMode?: OpportunityMode | null;
      reachedStatus: OpportunityStatus | null;
      publicStatus?: OpportunityPublicStatus | null;
      duplicatedOpportunity?: DuplicatedOpportunityModel | null;
    },
  ) {}
}

export class ResetOpportunitySetup {
  static readonly type = "[My Opportunities Setup] Reset Opportunity Setup";
}
